
import common from '@/utils/common'
import GridList from '@/components/GridList.vue';
export default {
  components: { GridList },
  name: 'SearchGrid',
  mixins: [common],
  props: {
    type: {
      type: String,
      default: ''
    },
    gridData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    setGridColSize() {
      const colSize = this.cols;
      return `col-${colSize}`;
    }
  },
  data() {
    return {
      formerVn: null,
    }
  },
  methods: {
    emitItem(item) {
      if(this.type === 'state') {
        this.$emit('selectState', item);
      }else if(this.type === 'city') {
        this.$emit('selectCity', item);
      }
    },
    async getProxyPhoneCall(item) {
      if(item.user_id == null)
        return alert('동대표 전화정보가 없습니다. 고객센터에 문의하세요');
      const { data } = await this.$axios.post(`/api/districts/${item.district_id}/members/proxy-number`, 
        {
          id: item.user_id,
          pvn: this.formerVn,
        }
      )
      if(data.rs == 'SUCCESS') {
        window.location.href = `tel:${data.vn}`
        this.formerVn = data.vn;
      }
    },
  },
}
